// import { Box, Flex, Text, useColorModeValue, Button } from '@chakra-ui/react';
// import Card from 'components/card/Card.js';
// // Custom components
// import React, { useEffect, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { getWhatsNew } from '../../../../redux/actions/dashboard';

// export default function WeeklyRevenue(props) {
//    const { ...rest } = props;
//    const [isOpen, setIsOpen] = React.useState(false);
//    const dispatch = useDispatch();
//    const whatsNew = useSelector((state) => state.dashboard.list || []);
//    // Chakra Color Mode
//    const marqueeRef = useRef(null);
//    const textColor = useColorModeValue('secondaryGray.900', 'white');
//    useEffect(() => {
//       dispatch(getWhatsNew());
//    }, [dispatch]);

//    const handleclose = (formData) => {
//       // onClose(true);
//       setIsOpen(false);
//    };

//    const handleSave = (formData) => {
//       // onClose(true);
//       setIsOpen(false);
//    };

//    return (
//       <>
//          <Flex justifyContent={{ base: 'center', lg: 'flex-end' }} w="100%" height={'100%'}>
//             <Card
//                justifyContent="end"
//                direction="column"
//                // w={{ base: '100%', sm: '90%', md: '80%', lg: '70%' }}
//                // ml={{base: '0', lg: 'auto'}}
//                // mr={{base: '0', lg: '0'}}
//                {...rest}>
//                <Flex align="center" w="100%" px="15px" py="10px">
//                   <Text me="auto" color={textColor} fontSize="xl" fontWeight="700" lineHeight="100%">
//                      {/* Weekly Revenue */}
//                      What's New
//                   </Text>
//                </Flex>

//                <Box h={props.height} mt="auto">
//                   <marquee
//                      behavior="scroll"
//                      ref={marqueeRef}
//                      direction="up"
//                      scrollamount="2"
//                      scrolldelay="10"
//                      onMouseEnter={(e) => marqueeRef.current?.stop?.()}
//                      onMouseLeave={(e) => marqueeRef.current?.start?.()}
//                      style={{
//                         fontSize: 'sm',
//                         fontWeight: 'medium',
//                         color: textColor,
//                         height: '100%',
//                         width: '95%',
//                      }}>
//                      {whatsNew.map((sentence, index) => (
//                         <>
//                            <span key={index} style={{ display: 'block', marginBottom: '20px' }}>
//                               {sentence.feature}{' '}
//                               <a
//                                  href={sentence.link}
//                                  target="_blank"
//                                  rel="noopener noreferrer"
//                                  style={{ color: textColor, textDecoration: 'underline' }}>
//                                  <strong>Click here</strong>
//                               </a>
//                            </span>
//                         </>
//                      ))}
//                   </marquee>
//                </Box>
//             </Card>
//          </Flex>
//       </>
//    );
// }

import React, { useEffect, useRef, useState } from 'react';
import { useColorMode } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getWhatsNew } from '../../../../redux/actions/dashboard';
import { Sparkles, ExternalLink, RotateCw } from 'lucide-react';

export default function WeeklyRevenue(props) {
   const { height = '300px', ...rest } = props;
   const [isOpen, setIsOpen] = React.useState(false);
   const [isRotating, setIsRotating] = useState(false);
   const dispatch = useDispatch();
   const whatsNew = useSelector((state) => state.dashboard.list || []);
   const marqueeRef = useRef(null);
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   useEffect(() => {
      dispatch(getWhatsNew());
   }, [dispatch]);

   const handleclose = (formData) => {
      setIsOpen(false);
   };

   const handleSave = (formData) => {
      setIsOpen(false);
   };

   const handleReload = () => {
      // if (isRotating) return; // prevent spam clicking
      setIsRotating(true);
      dispatch(getWhatsNew());
      setTimeout(() => setIsRotating(false), 700); // reset rotation after 1s
   };

   return (
      <div className="flex justify-center lg:justify-end w-full h-full">
         <div
            className={`rounded-2xl shadow-lg w-full h-full flex flex-col overflow-hidden border transition-all duration-300 ${isDark
               ? 'bg-gradient-to-br from-gray-800 via-gray-800 to-gray-900 border-gray-700'
               : 'bg-gradient-to-br from-white via-blue-50/30 to-purple-50/20 border-gray-200'
               }`}
            {...rest}>
            {/* Header */}
            <div
               className={`flex items-center gap-3 px-6 py-4 border-b ${isDark ? 'border-gray-700' : 'border-gray-200'
                  }`}>
               <div
                  className={`p-2 rounded-lg ${isDark ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-500/10 text-blue-600'
                     }`}>
                  <Sparkles className="w-5 h-5" />
               </div>
               <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>What's New</h2>
               <div
                  className={`ml-auto px-3 py-1 rounded-full text-xs font-semibold ${isDark ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-500/10 text-blue-600'
                     }`}>
                  {whatsNew.length} Updates
               </div>
               <button
                  onClick={handleReload}
                  className={`ml-2 p-2 rounded-full transition-all duration-300 hover:scale-110 ${isDark ? "hover:bg-gray-700 text-blue-400" : "hover:bg-gray-100 text-blue-600"
                     }`}
               >
                  <RotateCw
                     className={`w-5 h-5 transform ${isRotating ? "rotate-[360deg]" : ""
                        } transition-transform ease-in-out`}
                     style={{
                        transitionDuration: isRotating ? "700ms" : "10ms",
                     }}
                  />
               </button>
            </div>

            {/* Marquee Content */}
            <div
               className="flex-1 relative overflow-hidden"
               style={{ height: typeof height === 'string' ? height : `${height}px` }}>
               {/* Gradient Overlays */}
               <div
                  className={`absolute top-0 left-0 right-0 h-12 z-10 pointer-events-none ${isDark
                     ? 'bg-gradient-to-b from-gray-800 to-transparent'
                     : 'bg-gradient-to-b from-white to-transparent'
                     }`}
               />
               <div
                  className={`absolute bottom-0 left-0 right-0 h-12 z-10 pointer-events-none ${isDark
                     ? 'bg-gradient-to-t from-gray-800 to-transparent'
                     : 'bg-gradient-to-t from-white to-transparent'
                     }`}
               />

               <marquee
                  behavior="scroll"
                  ref={marqueeRef}
                  direction="up"
                  scrollamount="2"
                  scrolldelay="10"
                  onMouseEnter={(e) => marqueeRef.current?.stop?.()}
                  onMouseLeave={(e) => marqueeRef.current?.start?.()}
                  className="h-full w-full px-6 py-4">
                  {whatsNew.length > 0 ? (
                     whatsNew.map((sentence, index) => (
                        <div
                           key={index}
                           className={`mb-6 p-4 rounded-xl border transition-all duration-200 hover:scale-[1.02] ${isDark
                              ? 'bg-gray-700/50 border-gray-600 hover:bg-gray-700 hover:border-blue-500/50'
                              : 'bg-white/80 border-gray-200 hover:bg-white hover:border-blue-400/50 hover:shadow-md'
                              }`}>
                           <div className="flex items-start gap-3">
                              <div
                                 className={`mt-1 p-1.5 rounded-lg flex-shrink-0 ${isDark ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-500/10 text-blue-600'
                                    }`}>
                                 <div className="w-2 h-2 rounded-full bg-current animate-pulse" />
                              </div>
                              <div className="flex-1">
                                 <p
                                    className={`text-sm font-medium leading-relaxed mb-2 ${isDark ? 'text-gray-200' : 'text-gray-700'
                                       }`}>
                                    {sentence.feature}
                                 </p>
                                 <a
                                    href={sentence.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`inline-flex items-center gap-1.5 text-xs font-semibold transition-colors ${isDark
                                       ? 'text-blue-400 hover:text-blue-300'
                                       : 'text-blue-600 hover:text-blue-700'
                                       }`}>
                                    Learn More
                                    <ExternalLink className="w-3 h-3" />
                                 </a>
                              </div>
                           </div>
                        </div>
                     ))
                  ) : (
                     <div className="flex items-center justify-center h-full">
                        <div className={`text-center p-8 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                           <Sparkles className="w-12 h-12 mx-auto mb-3 opacity-50" />
                           <p className="text-sm font-medium">No updates available</p>
                        </div>
                     </div>
                  )}
               </marquee>

               {/* Hover Hint */}
               <div
                  className={`absolute bottom-4 right-4 text-xs font-medium opacity-50 pointer-events-none ${isDark ? 'text-gray-400' : 'text-gray-500'
                     }`}>
                  Hover to pause
               </div>
            </div>
         </div>
      </div>
   );
}
